import { useMemo } from 'react';
import dayjs from 'dayjs';

import CountDown from '~/components/CountDown';
import { usePlusMembershipEvent } from '~/domains/plusMembership/queries';

import { ChevronRightIcon, MembershipStandard28x14Icon } from '~/assets/icons';

type Props = {
  onClick?: () => void;
};

export function MembershipTrialCountdown({ onClick }: Props) {
  const { data } = usePlusMembershipEvent();

  const coundDown = useMemo(() => {
    if (!data?.event?.endAt) return undefined;
    return dayjs(data?.event?.endAt).valueOf() - dayjs().valueOf();
  }, [data?.event?.endAt]);

  if (!coundDown) return null;

  return (
    <div
      className="flex items-center justify-between rounded-16 bg-bonuspackGreen-backgroundLight p-16"
      onClick={onClick}
      role="presentation"
    >
      <p className="flex items-center text-bonuspackGreen-text typo-paragraph100-semibold">
        <MembershipStandard28x14Icon className="mr-4" />
        중복할인 <CountDown initialTime={coundDown} isDot /> 남음
      </p>
      <ChevronRightIcon />
    </div>
  );
}
